import { HStack, Link } from '@wegroup/design-system';
import { get } from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { handleResponseLanguage } from '../../../../../../../../i18n';
import useFlowsHelper from '../../../../../hooks/useFlowsHelper';
import { FlowsQuestionGroup } from '../../../../../types/FlowsTypes';
import { getHTMLIdForGroup } from '../../utils/helperFunctions';
import CompanyScanProgressCheckmark from './CompanyScanProgressCheckmark';

interface Props {
  group: FlowsQuestionGroup;
}

const CompanyScanProgressItem: React.FC<React.PropsWithChildren<Props>> = ({
  group,
}) => {
  const { getAnswersForGroup } = useFlowsHelper();
  const {
    formState: { errors },
  } = useFormContext();
  /** Filter out answers that are an empty array as they are not counting for a valid answer (uploadfields) */
  const answersForGroup = getAnswersForGroup(group.id, group.index).filter(
    ({ answer }) => !(Array.isArray(answer) && !answer.length),
  );
  const isChecked = answersForGroup.length >= group.questions.length;
  const isExtraRemarksGroup = group.id.includes('extra_remarks') && !isChecked;

  const handleOnClick = () => {
    document.getElementById(getHTMLIdForGroup(group))?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  const getGroupError = () => {
    return group.questions.some((question) => get(errors, question.id));
  };

  if (isExtraRemarksGroup) return null;

  return (
    <HStack spacing="3">
      <CompanyScanProgressCheckmark
        checked={answersForGroup.length >= group.questions.length}
        error={getGroupError()}
      />
      <Link variant="gray" onClick={handleOnClick}>
        {handleResponseLanguage(group.title)}
      </Link>
    </HStack>
  );
};

export default CompanyScanProgressItem;
